export default __webpack_public_path__ + "static/media/Flecha_up.19e362cd.svg";